<template>
    <a-tooltip placement="top" title="Click to copy Asset ID">
        <span
            style="cursor: pointer; text-decoration: underline"
            @click="copyAssetId"
        >
            Asset Id: {{ assetId }}
        </span>
    </a-tooltip>
</template>

<script>
export default {
    name: 'AssetIdTooltip',
    props: {
        assetId: {
            type: [Number, String],
            required: true,
            default: '',
        },
    },
    methods: {
        copyAssetId() {
            navigator.clipboard
                .writeText(this.assetId)
                .then(() => {
                    alert('Asset ID copied to clipboard');
                })
                .catch((err) => {
                    console.error('Failed to copy asset ID: ', err);
                    alert('Failed to copy Asset ID');
                });
        },
    },
};
</script>
